var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divcreateorder"},[_c('internationalfedex',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='FEDEX国际件'),expression:"type=='FEDEX国际件'"}],ref:"fedex",attrs:{"urlparam":_vm.pageparam,"curpkval":_vm.curpkval,"iscopy":_vm.iscopy}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }